module.exports = __webpack_public_path__ + "img/Icon_Driving_Distance_white.4f96d927.svg";